<template>
  <div v-if="product !== null">
    <!-- block1 product info -->
    <div class="block mb-5">
      <!-- Product Name -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Product Name</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="product.name"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- BU -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>BU</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="w-248px">
            <v-autocomplete
              v-model="product.bu_id"
              :items="buTabs"
              placeholder="請選擇所屬BU"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </label>
      <!-- Category -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Category</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="w-248px product-info-autocomplete">
            <v-autocomplete
              v-model="product.product_category_id"
              :items="categories"
              placeholder="請選擇所屬Category"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </label>
      <!-- SubCategory -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>SubCategory</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <div class="w-248px product-info-autocomplete">
            <v-autocomplete
              v-model="product.product_sub_category_id"
              :items="subcategories"
              placeholder="請選擇所屬SubCategory"
              item-text="name"
              item-value="id"
              outlined
              dense
            >
            </v-autocomplete>
          </div>
        </div>
      </label>
      <!-- Model Name -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Model Name</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="product.model_name"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Model Name SAP -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Model Name SAP</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="product.model_name_sap"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- First headline -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>First Headline</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="product.first_headline"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!--Second headline
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Second Headline</h4>
          <div class="h5 ink-02-medium--text">
            多值時請使用逗號隔開
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="product.second_headline"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      Second headline-->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>PI_ID</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="product.pi_id"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- ID -->
      <label class="form-item d-flex py-5">
        <div class="w-240px">
          <h4>ID</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex align-center">
          <div class="w-248px form-input-group">
            <input type="text" disabled :value="product.id" />
          </div>
          <div class="ml-10px ink-02-medium--text h5">(自動生成)</div>
        </div>
      </label>
      <!-- Order -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Order</h4>
          <div class="h5 ink-02-medium--text">
            資料降冪排序(數字越大顯示越前面)
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="product.order"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- 是否有downloadPage -->
      <label class="form-item d-flex py-5">
        <div class="w-240px">
          <h4>是否顯示DownloadPage</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="product.has_download_page"></FormSwitch>
        </div>
      </label>
      <!-- 是否有VideoPage -->
      <label class="form-item d-flex py-5">
        <div class="w-240px">
          <h4>是否顯示VideoPage</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="product.has_video_page"></FormSwitch>
        </div>
      </label>
      <!-- 顯示/隱藏 -->
      <label class="form-item d-flex py-5">
        <div class="w-240px">
          <h4>顯示/隱藏</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <FormSwitch v-model="product.status"></FormSwitch>
        </div>
      </label>
      <!-- 上架中/已下架 -->
      <label class="form-item d-flex py-5">
        <div class="w-240px">
          <h4>上架中/已下架</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <SegmentalControls
            class="mr-2"
            :buttons="statusOptions"
            v-model="product.main_status"
            itemStyle="style-basic"
          ></SegmentalControls>
        </div>
      </label>
      <!-- 特殊標示 -->
      <label class="form-item d-flex py-5">
        <div class="w-240px">
          <h4>特殊標示</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-autocomplete
              v-model="product.product_tags"
              :items="tagTypeOptions"
              placeholder="請選擇"
              item-text="text"
              item-value="value"
              outlined
              dense
            >
            </v-autocomplete>
        </div>
      </label>
    </div>
    <!-- block2 seo setting -->
    <div class="block mb-5">
      <h3 class="px-5 pt-5">SEO settings</h3>
      <!-- Title -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Title</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="product.seo_title"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
      <!-- Description -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Description</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="product.seo_description"
            outlined
            dense
          ></v-textarea>
        </div>
      </label>
      <!-- Keyword -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Keyword</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-textarea
            v-model="product.seo_keyword"
            outlined
            dense
          ></v-textarea>
        </div>
      </label>
      <!-- URL -->
      <label class="form-item d-flex pt-5">
        <div class="w-240px">
          <h4>Slug</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="product.slug"
            placeholder="可讀性URL"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
    </div>

    <!-- block3 產品封面照 -->
    <div class="block mb-5">
      <h3 class="px-5 pt-5">產品封面圖</h3>
      <div class="form-item py-5">
        封面圖將呈現於SubCategory Page (Product Overview)
      </div>
      <!-- Model Name -->
      <div class="d-flex pa-5">
        <div class="w-240px mr-5">
          <h4>Model Name</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <!-- head -->
          <div class="d-flex mb-1">
            <h4 class="w-160px mr-5">請輸入顏色名稱</h4>
            <h4 class="w-160px mr-5">請輸入HEX色碼</h4>
            <h4>請上傳產品圖</h4>
          </div>
          <!-- body -->
          <div>
            <div
              class="mb-5 d-flex"
              v-for="(color, index) in product.colors"
              :key="index"
            >
              <!-- color name -->
              <div class="w-160px mr-5">
                  <v-text-field
                    v-model="color.name"
                    outlined
                    dense
                  ></v-text-field>
              </div>
              <!-- hex -->
              <div class="w-160px mr-5">
                <v-text-field
                  v-model="color.hex"
                  placeholder="#"
                  outlined
                  dense
                >
                  <template v-slot:append>
                    <div class="append-icon">
                      <div
                        v-if="color.hex"
                        class="w-20px h-20px"
                        :style="{
                        'border-radius': '50%',
                        'background-color': color.hex,
                      }"
                      ></div>
                      <div
                        v-if="color.hex.trim() === ''"
                        class="w-20px h-20px transparent-circle"
                      ></div>
                    </div>
                  </template>
                </v-text-field>
              </div>
              <!-- upload -->
              <div class="d-flex">
                <ImgUploader
                  :imageUrl.sync="color.image"
                  :dir="'product'"></ImgUploader>
                <button class="btn btn-danger square ml-5" @click="removeProductColor(index)">
                  <v-icon color="white">delete</v-icon>
                </button>
              </div>
            </div>
          </div>
          <div>
            <button class="btn btn-outlined" @click="addProductColor">
              <v-icon color="brand-01-emphasis">add</v-icon>
              <span class="ml-2">新增顏色規格</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- block4 上稿方式 -->
    <div class="block mb-5">
      <!-- 請選擇產品頁上稿方式 -->
      <div class="form-item d-flex pt-5 pb-4">
        <div class="w-240px">
          <h4>請選擇產品頁上稿方式</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-radio-group v-model="product.is_landing_page" row>
            <v-radio
              :value="0"
              color="brand-600"
              class="h-20px mr-5"
            >
              <template v-slot:label>
                <div
                  class="h5 ink-01-emphasis--text d-flex align-center w-192px"
                >
                  從後台編輯
                </div>
              </template>
            </v-radio>
            <v-radio
              :value="1"
              color="brand-600"
              class="h-20px"
            >
              <template v-slot:label>
                <div class="h5 ink-01-emphasis--text d-flex align-center">
                  貼上LandingPage URL
                </div>
              </template>
            </v-radio>
          </v-radio-group>
        </div>
      </div>
      <!-- URL -->
      <label class="form-item d-flex py-5" v-if="product.is_landing_page == 1">
        <div class="w-240px">
          <h4>URL</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2">
          <v-text-field
            v-model="product.landing_page_url"
            prepend-inner-icon="mdi-link"
            outlined
            dense
          ></v-text-field>
        </div>
      </label>
    </div>

    <!-- block5 switch section from backstage -->
    <div class="block" v-if="product.is_landing_page == 0">
      <BackStageMenu :sections="backStageSections">
        <div
          v-for="(backStageSection, i) in backStageSections"
          :key="backStageSection.name + Math.random()"
        >
          <component
            v-if="i == sectionIndex"
            :is="sectionView"
            style="min-height: 588px;"
            :product="product"
          ></component>
        </div>
      </BackStageMenu>
    </div>

    <!-- block5 from URL -->
    <div class="block" v-if="product.is_landing_page == 1">
      <LandingPageURLMenu :sections="LandingPageUrlSections">
        <component
          :is="LandingPageUrlSections[0].component"
          style="min-height: 588px;"
          :product="product"
        ></component>
      </LandingPageURLMenu>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import MultiSelectWithCheckbox from '@/components/Selection/MultiSelectWithCheckbox.vue';
import FormSwitch from '@/components/FormSwitch.vue';
import SegmentalControls from '@/components/SegmentalControls.vue';
import EmptyLayout from '@/components/Layouts/EmptyLayout.vue';
import ImgUploader from '@/components/ImgUploader2.vue';

// wayToUpload: fromBackStage
import BackStageMenu from '@/views/C-3__Products/c/C-3-1a__ProductInfoEdit_BackStage.vue';
// import MainVisual from '@/views/C-3__Products/c/C-3-1a-1__ProductionInfoEdit_MainVisual.vue';
import InfoKSP from '@/views/C-3__Products/c/C-3-1a-2__ProductInfoEdit_Info&KSP.vue';
// import CompatibleProducts from '@/views/C-3__Products/c/C-3-1a-3__ProductInfoEdit_Compatible_Products.vue';
import Description from '@/views/C-3__Products/c/C-3-1a-4__ProductInfoEdit_Description.vue';
import ProductSpec from '@/views/C-3__Products/c/C-3-1a-4__ProductInfoEdit_Product Spec.vue';
// import ProductGallery from '@/views/C-3__Products/c/C-3-1a-5__ProductInfoEdit_ProductGallery.vue';
import ProductTech from '@/views/C-3__Products/c/C-3-1a-6__ProductInfoEdit_Application_Technology.vue';

// wayToUpload: fromURL
import LandingPageURLMenu from '@/views/C-3__Products/c/C-3-1b__ProductInfoEdit_LandingPageURL.vue';
import LandingPageUrlProductSpec from '@/views/C-3__Products/c/C-3-1b-9__ProductInfoEdit_LandingPageURL__ProductSpec.vue';

export default {
  components: {
    MultiSelectWithCheckbox,
    FormSwitch,
    SegmentalControls,
    LandingPageURLMenu,
    LandingPageUrlProductSpec,
    BackStageMenu,
    // MainVisual,
    InfoKSP,
    // CompatibleProducts,
    Description,
    ProductSpec,
    // ProductGallery,
    EmptyLayout,
    ImgUploader,
    ProductTech,
  },
  data: () => ({
    statusOptions: [{
      value: 1,
      title: '上架中',
    }, {
      value: 0,
      title: '已下架',
    }],
    bu: [],
    categories: [],
    subcategories: [],
    isShow: true,
    statusOfOnStore: '上架中',

    backStageSections: [
      /* {
        name: 'Main Visual',
        component: 'MainVisual',
      }, */
      {
        name: 'Product Features',
        component: 'InfoKSP',
      },
      /* {
        name: 'Compatible Products',
        component: 'CompatibleProducts',
      }, */
      {
        name: 'Description & Video',
        component: 'Description',
      },
      {
        name: 'Product Spec',
        component: 'ProductSpec',
      },
      /* {
        name: 'Product Gallery',
        component: 'ProductGallery',
      }, */
      {
        name: 'Technology',
        component: 'ProductTech',
      },
    ],
    LandingPageUrlSections: [
      {
        name: 'Product Spec',
        component: 'LandingPageUrlProductSpec',
      },
    ],
    isFirstLoad: true,
    newLoadSpec: false,
  }),
  computed: {
    ...mapState(['buTabs']),
    ...mapState('product', ['product', 'tagTypeOptions']),
    sectionIndex() {
      const vm = this;
      return vm.$route.query.section || 0;
    },
    sectionView() {
      const vm = this;
      return vm.backStageSections[vm.sectionIndex].component;
    },
    videoIndex() {
      // Main Visual, Porduct Information, then Product Video
      return this.sectionIndex - 2;
    },
  },
  async created() {
    if (this.product.bu_id !== null) {
      this.categories = await this.getCategories(this.product.bu_id);
    }
    if (!this.product.id) {
      this.isFirstLoad = false;
    }
  },
  watch: {
    async 'product.bu_id'(newValue) {
      if (!this.isFirstLoad) {
        this.product.specs = [];
        this.product.product_sub_category_id = null;
      }
      this.categories = await this.getCategories(newValue);
    },
    async 'product.product_category_id'(newValue) {
      if (!this.isFirstLoad) {
        this.product.specs = [];
        this.product.product_sub_category_id = null;
      }
      this.subcategories = await this.getSubCategories(newValue);
    },
    async 'product.product_sub_category_id'(newValue) {
      if (newValue === null || newValue === '' || newValue === undefined) {
        return;
      }
      const pThis = this;
      await this.getSubCategory(newValue).then((data) => {
        if (!pThis.isFirstLoad) {
          pThis.product.specs = [];
          data.specs.forEach((sepc) => {
            pThis.product.specs.push({
              ...sepc,
              options: [{
                id: null,
                title: null,
              }],
            });
          });
        }
        pThis.isFirstLoad = false;
      });
    },
  },
  methods: {
    ...mapActions('category', {
      getCategories: 'allByBu',
    }),
    ...mapActions('subcategory', {
      getSubCategories: 'allByCategory',
      getSubCategory: 'findById',
    }),
    addProductColor() {
      const template = {
        id: null,
        name: '',
        hex: '',
        image: '',
        images: [],
      };
      this.product.colors.push(template);
    },
    removeProductColor(index) {
      this.product.colors.splice(index, 1);
    },
  },
};
</script>

<style lang="scss">
.transparent-circle {
  border-radius: 50%;
  background: #fff;
  background-image: linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.25) 25%,
      transparent 0,
      transparent 75%,
      rgba(0, 0, 0, 0.25) 0
    ),
    linear-gradient(
      45deg,
      rgba(0, 0, 0, 0.25) 25%,
      transparent 0,
      transparent 75%,
      rgba(0, 0, 0, 0.25) 0
    );
  background-position: 0 0, 5px 5px;
  background-size: 10px 10px;
}
</style>
